// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1T7HN","header":"ClearentDisclaimer_header__ruKkY","inner":"ClearentDisclaimer_inner__2w5oZ"};